export default function menuScroll() {

	let lastScrollY = window.scrollY;
	let passedTheValue = false;

	window.addEventListener('scroll', () => {
		const currentScrollY = window.scrollY;

		// Ha valaha túlléptük a 100px-et
		if (currentScrollY > 100) {
			passedTheValue = true;
		}

		// Ha visszagörgettünk 100px alá, reset
		if (currentScrollY <= 100) {
			document.body.classList.remove('scrolling-up');
			passedTheValue = false;
		}

		// Ha már jártunk 100 alatt, és most felfelé görgetünk
		if (passedTheValue && currentScrollY < lastScrollY) {
			document.body.classList.add('scrolling-up');
		}

		// Ha lefelé görgetünk
		if (currentScrollY > lastScrollY) {
			document.body.classList.remove('scrolling-up');
		}

		lastScrollY = currentScrollY;
	});

}